module.exports = "/static/media/delete_icon.745442b1.svg";